import { render, staticRenderFns } from "./login.vue?vue&type=template&id=f97ae0a8"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLink: require('/vercel/path0/components/shared/AppLink.vue').default,CornerButton: require('/vercel/path0/components/shared/CornerButton.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default})
